// The latin woff2 file for each typeface, resolved to its built URL only when
// the design kit is downloaded. Kept beside the kit rather than with the font
// loaders, so the React package does not carry it.
type FileModule = Promise<{ default: string }>
export const fontFiles: Record<string, () => FileModule> = {
  'instrument-serif': () => import('@fontsource/instrument-serif/files/instrument-serif-latin-400-normal.woff2?url'),
  newsreader: () => import('@fontsource-variable/newsreader/files/newsreader-latin-wght-normal.woff2?url'),
  fraunces: () => import('@fontsource-variable/fraunces/files/fraunces-latin-wght-normal.woff2?url'),
  'source-serif': () => import('@fontsource-variable/source-serif-4/files/source-serif-4-latin-wght-normal.woff2?url'),
  inter: () => import('@fontsource-variable/inter/files/inter-latin-wght-normal.woff2?url'),
  geist: () => import('@fontsource-variable/geist/files/geist-latin-wght-normal.woff2?url'),
  'public-sans': () => import('@fontsource-variable/public-sans/files/public-sans-latin-wght-normal.woff2?url'),
  figtree: () => import('@fontsource-variable/figtree/files/figtree-latin-wght-normal.woff2?url'),
  'roboto-slab': () => import('@fontsource-variable/roboto-slab/files/roboto-slab-latin-wght-normal.woff2?url'),
  atkinson: () =>
    import('@fontsource-variable/atkinson-hyperlegible-next/files/atkinson-hyperlegible-next-latin-wght-normal.woff2?url'),
  plex: () => import('@fontsource-variable/ibm-plex-sans/files/ibm-plex-sans-latin-wght-normal.woff2?url'),
  'geist-mono': () => import('@fontsource-variable/geist-mono/files/geist-mono-latin-wght-normal.woff2?url'),
}
